import React, { useState } from 'react';
import { Button } from '../UI/Button';
import { Link, useNavigate } from 'react-router-dom';
import { Dialog } from '../UI/Dialog';
interface FooterProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
}
export const Footer = ({
  openRegistrationForm,
  openHostSalonForm
}: FooterProps) => {
  const [isNewsletterOpen, setIsNewsletterOpen] = useState(false);
  const navigate = useNavigate();
  const handleJoinNowClick = () => {
    // Navigate to the access points section on the home page
    if (window.location.pathname === '/') {
      // If already on home page, find and scroll to the access points section
      const accessPointsSection = document.querySelector('section.py-16.bg-gray-50');
      if (accessPointsSection) {
        accessPointsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      // If on another page, navigate to home and then to access points
      navigate('/?scrollToAccessPoints=true');
    }
  };
  const footerSections = [{
    title: 'About',
    links: [{
      name: 'Mission',
      path: '/about#vision-mission-values'
    }, {
      name: 'Vision',
      path: '/about#vision-mission-values'
    }, {
      name: 'Values',
      path: '/about#vision-mission-values'
    }, {
      name: 'Team',
      path: '/about'
    }, {
      name: 'Partners',
      path: '/partners'
    }]
  }, {
    title: 'Connect',
    links: [{
      name: 'Join the Salon',
      action: handleJoinNowClick
    }, {
      name: 'Host a Salon',
      path: '/host-salon'
    }, {
      name: 'Partner with Us',
      path: '/partner-with-us'
    }, {
      name: 'Join Our Team',
      path: '/join-team'
    }, {
      name: 'Newsletter',
      path: '#',
      isForm: true,
      formType: 'newsletter'
    }]
  }, {
    title: 'Resources',
    links: [{
      name: 'Blog',
      path: '/blog'
    }, {
      name: 'Toolkits',
      path: '/toolkits'
    }, {
      name: 'Networking Guides',
      path: '/networking-guide'
    }, {
      name: 'FAQs',
      path: '/faq'
    }]
  }, {
    title: 'Legal',
    links: [{
      name: 'Privacy Policy',
      path: '/privacy-policy'
    }, {
      name: 'Terms of Service',
      path: '/terms-of-service'
    }, {
      name: 'Cookie Policy',
      path: '/cookie-policy'
    }]
  }];
  return <footer className="bg-secondary/10 border-t border-secondary/20" data-id="element-777" data-mp="2w5vv04ci5o29">
      <div className="container mx-auto px-4 py-12" data-id="element-778" data-mp="2w76xm0u7oprs">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-779" data-mp="2r69hdtsri5sx">
          <div data-id="element-780" data-mp="2m7pr5h74y7ur">
            <div className="flex items-center" data-id="element-781" data-mp="2m76by88vdxkf">
              <div className="h-20" data-id="element-782" data-mp="2m7y75hyk1ta6">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rVLoSkFZL9a8o5YzEX4uvV/Logo_and_Teashirt_branding.png" alt="The Networking Salon Logo" className="h-full" data-id="element-783" data-mp="2h8v2hymhlp2q" />
              </div>
            </div>
            <p className="mt-4 text-secondary" data-id="element-784" data-mp="fh06ssgmlv65">
              Where connection unlocks opportunity.
            </p>
            <div className="mt-6" data-id="element-785" data-mp="nxh906ln82am">
              <Button onClick={handleJoinNowClick} data-id="element-786" data-mp="nw62w04q6igc">Join the Salon</Button>
            </div>
          </div>
          {footerSections.map(section => <div key={section.title} data-id="element-787" data-mp="wq2g2pfwwkjm">
              <h3 className="font-medium text-lg text-secondary-dark" data-id="element-788" data-mp="wr419mqn6nf2">
                {section.title}
              </h3>
              <ul className="mt-4 space-y-2" data-id="element-789" data-mp="11rrtucuircbe">
                {section.links.map(link => <li key={link.name} data-id="element-790" data-mp="50zan6cah45e">
                    {link.isForm ? <a href="#" onClick={e => {
                e.preventDefault();
                if (link.formType === 'newsletter') {
                  setIsNewsletterOpen(true);
                }
              }} className="text-secondary hover:text-primary hover:underline" data-id="element-791" data-mp="90gfpynszza1">
                        {link.name}
                      </a> : link.action ? <a href="#" onClick={e => {
                e.preventDefault();
                link.action();
              }} className="text-secondary hover:text-primary hover:underline" data-id="element-792" data-mp="1peq4gtvyjq1e">
                        {link.name}
                      </a> : <Link to={link.path} className="text-secondary hover:text-primary hover:underline" data-id="element-793" data-mp="2yc6eyybxenu8">
                        {link.name}
                      </Link>}
                  </li>)}
              </ul>
            </div>)}
        </div>
        <div className="mt-12 pt-6 border-t border-secondary/20 flex flex-col md:flex-row justify-between items-center" data-id="element-794" data-mp="37btibpo7u3px">
          <p className="text-secondary text-sm" data-id="element-795" data-mp="3m8klma10fzkt">
            © {new Date().getFullYear()} The Networking Salon. All rights
            reserved.
          </p>
          <div className="mt-4 md:mt-0 flex space-x-4" data-id="element-796" data-mp="3v2yvfx2ruhwj">
            <a href="https://www.linkedin.com/showcase/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="p-2 border border-secondary/30 rounded-full hover:border-primary hover:bg-primary/5 transition-colors" data-id="element-797" data-mp="3v4jr5q0to6vz">
              <div className="w-5 h-5 bg-secondary rounded-full" data-id="element-798" data-mp="3webexb4wa90"></div>
            </a>
            <a href="https://www.instagram.com/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="p-2 border border-secondary/30 rounded-full hover:border-primary hover:bg-primary/5 transition-colors" data-id="element-799" data-mp="nhxzyity587y">
              <div className="w-5 h-5 bg-secondary rounded-full" data-id="element-800" data-mp="dkjkomjreph8"></div>
            </a>
            <a href="#" className="p-2 border border-secondary/30 rounded-full hover:border-primary hover:bg-primary/5 transition-colors" data-id="element-801" data-mp="iil6hf8kl2we">
              <div className="w-5 h-5 bg-secondary rounded-full" data-id="element-802" data-mp="4qohhk277948"></div>
            </a>
          </div>
        </div>
      </div>
      {/* Newsletter Dialog */}
      <Dialog isOpen={isNewsletterOpen} onClose={() => setIsNewsletterOpen(false)} title="Subscribe to Our Newsletter" data-id="element-803" data-mp="3qywpv9k2jquc">
        <div className="p-6 text-center" data-id="element-804" data-mp="3vwy51jedj60j">
          <h3 className="text-xl font-bold mb-4" data-id="element-805" data-mp="3vvn4rtk50ge6">Subscribe on LinkedIn</h3>
          <p className="mb-6" data-id="element-806" data-mp="3hz9p8pz5yp2c">
            Stay updated with the latest events, opportunities, and success
            stories.
          </p>
          <div className="flex justify-center mb-6" data-id="element-807" data-mp="1sgukwu1tfg43">
            <a className="flex flex-col justify-center px-7 py-3 text-center text-white no-underline rounded-2xl bg-[#0A66C2] font-sans w-[200px] h-[32px]" href="https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=6970049734086377472" target="_blank" rel="noopener noreferrer" data-id="element-808" data-mp="1shmi29b29lwh">
              Subscribe on LinkedIn
            </a>
          </div>
          <Button variant="outline" onClick={() => setIsNewsletterOpen(false)} data-id="element-809" data-mp="2bfgr2nc6vxev">
            Close
          </Button>
        </div>
      </Dialog>
    </footer>;
};